import { render, staticRenderFns } from "./premium-iconfukidashi.vue?vue&type=template&id=1fac5970&scoped=true"
import script from "./premium-iconfukidashi.vue?vue&type=script&lang=js"
export * from "./premium-iconfukidashi.vue?vue&type=script&lang=js"
import style0 from "./premium-iconfukidashi.vue?vue&type=style&index=0&id=1fac5970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac5970",
  null
  
)

export default component.exports